const templateFontList = [
  "Anton",
  "Bebas Neue",
  "Comfortaa",
  "Dancing Script",
  "Graduate",
  "Lobster",
  "Lora",
  "Montserrat",
  "Oswald",
  "Pacifico",
  "Playfair Display",
  "Racing Sans One",
  "Roboto",
  "Sacramento",
  "Tourney",
];

function imageHasTag(image, inputTag) {
  if (!image.keywords) {
    return false;
  }

  const allTags = inputTag.split(/\|/);
  for (const tag of allTags) {
    if (imageHasSingleTag(image, tag)) {
      return true;
    }
  }
  return false;
}

const imageHasSingleTag = (image, tag) => {
  if (tag.includes(":")) {
    const tags = tag.split(/:/g);
    // Must include all tags:
    for (const tag of tags) {
      if (image.keywords.indexOf(tag) < 0) {
        return false;
      }
    }
    return true;
  } else if (tag.includes("/")) {
    const tags = tag.split(/\//g);
    // Must include one tag:
    for (const tag of tags) {
      if (image.keywords.indexOf(tag) >= 0) {
        return true;
      }
    }
    return false;
  }

  return image.keywords.indexOf(tag) >= 0;
};

module.exports = {
  imageHasTag,
  templateFontList,
};
